// src/data/API/ManualMembers.ts
import { apiFetch } from "../../lib/utils";

const ManualMembersEndPoint = "/ManualMembers";

export type ManualMember = {
  customerOrgId: string;
  customerName: string;
  contactPerson: string;
  lastReviewed: string; // "yyyy-MM-dd" | "N/A"
};

export const ManualMembers = {
  getForSupplier: async (supplierOrgId: string): Promise<ManualMember[]> => {
    try {
      const res = await apiFetch(`${ManualMembersEndPoint}/api/${supplierOrgId}`);
      if (!res.ok) throw new Error(await res.text());
      return await res.json();
    } catch (e) {
      console.error("Failed to fetch manual members:", e);
      return [];
    }
  },

  create: async (
    supplierOrgId: string,
    payload: { customerOrgId: string; customerName: string; contactPerson: string }
  ): Promise<ManualMember | null> => {
    try {
      const res = await apiFetch(
        `${ManualMembersEndPoint}/api/${supplierOrgId}`,
        "POST",
        JSON.stringify(payload),
        { "Content-Type": "application/json" }
      );
      if (!res.ok) throw new Error(await res.text());
      return await res.json();
    } catch (e) {
      console.error("Failed to create manual member:", e);
      return null;
    }
  },

  update: async (
    supplierOrgId: string,
    customerOrgId: string,
    payload: { customerName: string; contactPerson: string }
  ): Promise<Pick<ManualMember, "customerOrgId" | "customerName" | "contactPerson"> | null> => {
    try {
      const res = await apiFetch(
        `${ManualMembersEndPoint}/api/${supplierOrgId}/${customerOrgId}`,
        "PUT",
        JSON.stringify(payload),
        { "Content-Type": "application/json" }
      );
      if (!res.ok) throw new Error(await res.text());
      return await res.json();
    } catch (e) {
      console.error("Failed to update manual member:", e);
      return null;
    }
  },

  remove: async (supplierOrgId: string, customerOrgId: string): Promise<boolean> => {
    try {
      const res = await apiFetch(`${ManualMembersEndPoint}/api/${supplierOrgId}/${customerOrgId}`, "DELETE");
      if (!res.ok) throw new Error(await res.text());
      return true;
    } catch (e) {
      console.error("Failed to delete manual member:", e);
      return false;
    }
  },
};
